import { THE_COSMOPOLITAN } from "../../scripts/core/constants";
import { useStoreDollHouseMap } from "../../store";
import { useEffect, useState } from "react";
import {
  animationStart,
  animationEnd,
  showPopupWithContent,
  hidePopup,
} from "../../components/customEvents.js";
import { shallow } from "zustand/shallow";

export default function CosmopolitanLevel_Hotspots({
  hoverContent,
  selectedAria,
}) {
  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      currentCosmoPolitanLevel: state.currentCosmoPolitanLevel,
      destinationPoidSelected: state.destinationPoidSelected,
      sourcePoidSelected: state.sourcePoidSelected,
      CosmoHighlightPoiStore: state.CosmoHighlightPoiStore,
      resetCosmoHighlightPOI: state.resetCosmoHighlightPOI,
    }),
    shallow
  );

  const [currentAria, setCurrentAria] = useState(selectedAria);

  const [destcosmoCheckIn, setdestcosmoCheckIn] = useState("");
  const [destcosmoGuestElevators, setdestcosmoGuestElevators] = useState("");
  const [destcosmoChelsea, setdestcosmoChelsea] = useState("");

  const [sourcecosmoCheckIn, setsourcecosmoCheckIn] = useState("");
  const [sourcecosmoGuestElevators, setsourcecosmoGuestElevators] =
    useState("");
  const [sourcecosmoChelsea, setsourcecosmoChelsea] = useState("");

  const [highlightarias, setHighlightArias] = useState(null);

  useEffect(() => {
    setCurrentAria(dollhouseStore.currentCosmoPolitanLevel);
  }, [selectedAria]);

  useEffect(() => {
    setCurrentAria(dollhouseStore.currentCosmoPolitanLevel);
  }, [dollhouseStore.currentCosmoPolitanLevel]);

  /*
   * COSMO POLITAN  EXIST Route POI HIGHLIGHTING [start]
   */
  useEffect(() => {
    if (dollhouseStore.destinationPoidSelected === "") {
      setdestcosmoCheckIn("");
      setdestcosmoGuestElevators("");
      setdestcosmoChelsea("");
    }

    if (dollhouseStore.destinationPoidSelected === "cosmo_check_in") {
      setdestcosmoCheckIn("active-poi-selection");
      setdestcosmoGuestElevators("");
      setdestcosmoChelsea("");
    }

    if (dollhouseStore.destinationPoidSelected === "cosmo_convention_area_2") {
      setdestcosmoCheckIn("");
      setdestcosmoGuestElevators("active-poi-selection");
      setdestcosmoChelsea("");
    }
    if (dollhouseStore.destinationPoidSelected === "cosmo_convention_area_3") {
      setdestcosmoCheckIn("");
      setdestcosmoGuestElevators("");
      setdestcosmoChelsea("active-poi-selection");
    }
  }, [dollhouseStore.destinationPoidSelected]);

  useEffect(() => {
    if (dollhouseStore.sourcePoidSelected === "") {
      setsourcecosmoCheckIn("");
      setsourcecosmoGuestElevators("");
      setsourcecosmoChelsea("");
    }

    if (dollhouseStore.sourcePoidSelected === "cosmo_check_in") {
      setsourcecosmoCheckIn("active-poi-selection");
      setsourcecosmoGuestElevators("");
      setsourcecosmoChelsea("");
    }

    if (dollhouseStore.sourcePoidSelected === "cosmo_convention_area_2") {
      setsourcecosmoCheckIn("");
      setsourcecosmoGuestElevators("active-poi-selection");
      setsourcecosmoChelsea("");
    }
    if (dollhouseStore.sourcePoidSelected === "cosmo_convention_area_3") {
      setsourcecosmoCheckIn("");
      setsourcecosmoGuestElevators("");
      setsourcecosmoChelsea("active-poi-selection");
    }
  }, [dollhouseStore.sourcePoidSelected]);

  /*
   * COSMO POLITAN  EXIST Route POI HIGHLIGHTING [end]
   */

  /*
   * COSMO POLITAN NOT EXIST Route POI HIGHLIGHTING [start]
   */
  useEffect(() => {
    setHighlightArias(dollhouseStore.CosmoHighlightPoiStore);
  }, [dollhouseStore.CosmoHighlightPoiStore]);
  /*
   * COSMO POLITAN NOT EXIST Route POI HIGHLIGHTING [ends]
   */

  if (currentAria === THE_COSMOPOLITAN) {
    return (
      <CosmoLevel1
        hoverContent={hoverContent}
        destcosmoCheckIn={destcosmoCheckIn}
        sourcecosmoCheckIn={sourcecosmoCheckIn}
        highlightarias={highlightarias}
        resetCosmoHighlightPOI={dollhouseStore.resetCosmoHighlightPOI}
      />
    );
  }
  if (currentAria === "cosmo_level_1") {
    return (
      <CosmoLevel1
        hoverContent={hoverContent}
        destcosmoCheckIn={destcosmoCheckIn}
        sourcecosmoCheckIn={sourcecosmoCheckIn}
        highlightarias={highlightarias}
        resetCosmoHighlightPOI={dollhouseStore.resetCosmoHighlightPOI}
      />
    );
  }
  if (currentAria === "cosmo_level_2") {
    return (
      <CosmoLevel2
        hoverContent={hoverContent}
        destcosmoGuestElevators={destcosmoGuestElevators}
        sourcecosmoGuestElevators={sourcecosmoGuestElevators}
        highlightarias={highlightarias}
        resetCosmoHighlightPOI={dollhouseStore.resetCosmoHighlightPOI}
      />
    );
  }
  if (currentAria === "cosmo_level_3") {
    return (
      <CosmoLevel3
        hoverContent={hoverContent}
        destcosmoChelsea={destcosmoChelsea}
        sourcecosmoChelsea={sourcecosmoChelsea}
        highlightarias={highlightarias}
        resetCosmoHighlightPOI={dollhouseStore.resetCosmoHighlightPOI}
      />
    );
  }
  if (currentAria === "cosmo_level_4") {
    return (
      <CosmoLevel4
        hoverContent={hoverContent}
        highlightarias={highlightarias}
        resetCosmoHighlightPOI={dollhouseStore.resetCosmoHighlightPOI}
      />
    );
  }
}

function CosmoLevel1({
  hoverContent,
  destcosmoCheckIn,
  sourcecosmoCheckIn,
  highlightarias,
  resetCosmoHighlightPOI,
}) {
  const [restaurentActive, setrestaurentActive] = useState("");

  useEffect(() => {
    document.querySelectorAll(".poi-hover").forEach((val) => {
      val.classList.remove("active-poi");
    });
    setrestaurentActive("");

    if (highlightarias !== "") {
      if (highlightarias === "cosmo_district") {
        setrestaurentActive("active-poi");
      } else {
        if (document.getElementById(highlightarias)) {
          document.getElementById(highlightarias).classList.add("active-poi");
        }
      }
    }
  }, [highlightarias]);

  return (
    <>
      <g transform="translate(3482.133 1769.793)">
        <path
          className={`poi-hover`}
          id="cosmo_guest_elevators"
          onTouchStart={(e) => {
            showPopupWithContent(e, "cosmo_guest_elevators");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("cosmo_guest_elevators");
            showPopupWithContent(e, "cosmo_guest_elevators");
          }}
          onMouseLeave={(e) => {
            animationEnd("cosmo_guest_elevators");
            hidePopup("cosmo_guest_elevators");
            resetCosmoHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("cosmo_guest_elevators");
            resetCosmoHighlightPOI("");
          }}
          d="M344.844,1209.974h42.717v-83H344.844Z"
          transform="translate(-5.427 -16.168)"
          fill="rgba(255,255,255,0.02)"
        />

        <path
          className={`poi-hover ${destcosmoCheckIn} ${sourcecosmoCheckIn}`}
          id="cosmo_check_in"
          d="M-3065.786-11061.91h12.64l136.318,14.385-1.281,18.914,8.692,5.863,5.111,5.958,1.807,7.383-.763,8.187-2.768,6.242-4.477,4.95-4.429,3.258-6,3.2v15.652h10.064l-.59,20.443-.593,3.31-1.382,19.773-.626,3.523-.912,19.908-.63,3.294-1.2,19.889-.576,3.436-1.249,20.063h-12.019l-4.2,63.66,4.9,3.321,5.975,4.12,2.709,2.812,1.848,3.5,2.024,5.44v6.5l-2.024,6.317-4.558,6.393-6.264,4.109-9.083,3.2-45.156-2.856,5.193-8.739,2.686-8.426v-9.876l-2.686-7.8-4.04-7.25-5.894-6.123-8.608-5.316-8.7-1.885h-10.263l-8.971,1.885-8.209,6.155-4.659,5.284-3.444,5.894-2.3,7.335v11.7l1.391,6.853,6.115,10.313-49.829-1.086v-9.227h-30.755v-73.435l5.435-54.374-10.616-3.087,14.76-82.321,12.093,1.99,15.733-85.793Z"
          transform="translate(3197.907 11291.261)"
          fill="rgba(255,255,255,0.05)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "cosmo_check_in");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("cosmo_check_in");
            showPopupWithContent(e, "cosmo_check_in");
          }}
          onMouseLeave={(e) => {
            animationEnd("cosmo_check_in");
            hidePopup("cosmo_check_in");
            resetCosmoHighlightPOI();
          }}
        />

        <g
          fill="rgba(255,255,255,0.05)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "cosmo_level_1_restaurent");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("cosmo_level_1_restaurent");
            showPopupWithContent(e, "cosmo_level_1_restaurent");
            setrestaurentActive("active-poi");
          }}
          onMouseLeave={(e) => {
            animationEnd("cosmo_level_1_restaurent");
            hidePopup("cosmo_level_1_restaurent");
            setrestaurentActive("");
            resetCosmoHighlightPOI();
          }}
          id="cosmo_district"
          className={`poi-hover ${restaurentActive}`}
          transform="translate(8.641 601.646)"
        >
          <path
            id="Path_2075"
            data-name="Path 2075"
            d="M-3204.979-10270.917l11.3-5.571,9.733-6.833,9.359-8.024,7.845-8.616,33.894,11.781-20.851,93.648-4.2,7.074-6.342,2.37h-6.057l-5.961-3.985-5.206-6.921-2.568-8.712-2.8-14.506-1.925-7.769-2.187-8.579-2.74-8.458-2.932-9.022-2.925-7.416Z"
            transform="translate(3222.472 10382.354)"
          />

          <g
            id="Rectangle_4255"
            data-name="Rectangle 4255"
            transform="translate(250.226 -0.439)"
          >
            <rect width="38" height="66" stroke="none" />
            <rect x="2.5" y="2.5" width="33" height="61" fill="none" />
          </g>
          <path
            id="Path_2076"
            data-name="Path 2076"
            d="M-2762.777-9302.795l16.469.03v18.075l75.65.567-.334,41.057-72.3-.825-18.95-13.515Z"
            transform="translate(3044.152 9980.24)"
          />
          <g
            id="Rectangle_4256"
            data-name="Rectangle 4256"
            transform="translate(0.226 825.561)"
          >
            <rect width="79" height="38" stroke="none" />
            <rect x="2.5" y="2.5" width="74" height="33" fill="none" />
          </g>
          <path
            id="Path_2077"
            data-name="Path 2077"
            d="M-2769.221-9137.2h58.013l20.247,32.133-22.608,53.076-96.6-.03v-8.322h41.021Z"
            transform="translate(3063.263 9913.462)"
          />
        </g>
      </g>
    </>
  );
}

function CosmoLevel2({
  hoverContent,
  destcosmoGuestElevators,
  sourcecosmoGuestElevators,
  highlightarias,
  resetCosmoHighlightPOI,
}) {
  const [conventionActive, setActiveConvention] = useState("");
  const [restaurentActive, setrestaurentActive] = useState("");

  useEffect(() => {
    document.querySelectorAll(".poi-hover").forEach((val) => {
      val.classList.remove("active-poi");
    });
    setrestaurentActive("");

    if (highlightarias !== "") {
      if (highlightarias === "cosmo_convention_area_2") {
        setActiveConvention("active-poi");
      } else if (highlightarias === "cosmo_district") {
        setrestaurentActive("active-poi");
      } else {
        if (document.getElementById(highlightarias)) {
          document.getElementById(highlightarias).classList.add("active-poi");
        }
      }
    }
  }, [highlightarias]);

  return (
    <>
      <g transform="translate(3485.331 1884.251)">
        <g
          className={`poi-hover ${restaurentActive}`}
          id="cosmo_district"
          fill="rgba(255,255,255,0)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "cosmo_level_2_restaurent");
            setrestaurentActive("active-poi");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("cosmo_level_2_restaurent");
            showPopupWithContent(e, "cosmo_level_2_restaurent");
            setrestaurentActive("active-poi");
          }}
          onMouseLeave={(e) => {
            animationEnd("cosmo_level_2_restaurent");
            hidePopup("cosmo_level_2_restaurent");
            setrestaurentActive("");
            resetCosmoHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("cosmo_level_2_restaurent");
            setrestaurentActive("");
            resetCosmoHighlightPOI("");
          }}
        >
          <g
            id="Rectangle_4258"
            data-name="Rectangle 4258"
            transform="translate(114.669 824.749)"
          >
            <rect width="94" height="87" stroke="none" />
            <rect x="2.5" y="2.5" width="89" height="82" fill="none" />
          </g>

          <path
            id="Path_2079"
            data-name="Path 2079"
            d="M-3239.813-9653.21h46.346l31.63,25.117v39.166h-77.976Z"
            transform="translate(3241.962 10608.736)"
          />

          <g
            id="Path_2080"
            data-name="Path 2080"
            transform="translate(207.157 824.964)"
          >
            <path d="M1.879,0H56.852l.823,175.915L2.03,138.9Z" />
          </g>

          <path
            id="Path_2081"
            data-name="Path 2081"
            d="M-2836.978-9537.5h54.887v73.727H-2823.5l-14.036-26.4Z"
            transform="translate(3079.743 10562.076)"
          />
          <path
            id="Path_2082"
            data-name="Path 2082"
            d="M-2742.434-9229.741l130.1-.772.708,36.938-53.987,101.71-93.921-101.456Z"
            transform="translate(3048.287 10438.281)"
          />

          <path
            id="Path_2095"
            data-name="Path 2095"
            d="M-3243.2-11254.443l170.817.093v107.989h32.064l-17.884,45.772-67.445-.157-.267,202.714h-117.5Z"
            transform="translate(3243.415 11254.443)"
          />
          <path
            id="Path_2255"
            data-name="Path 2255"
            d="M-5326.466-11344.688v19.429h23.941v-21.937h-23.941Z"
            transform="translate(5608 12524)"
          />

          <g
            id="Rectangle_4262"
            data-name="Rectangle 4262"
            transform="translate(258.669 0.749)"
          >
            <rect width="85" height="101" stroke="none" />
            <rect x="2.5" y="2.5" width="80" height="96" fill="none" />
          </g>
        </g>
      </g>

      <g
        className={`poi-hover`}
        id="cosmo_guest_elevators"
        onTouchStart={(e) => {
          showPopupWithContent(e, "cosmo_guest_elevators");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("cosmo_guest_elevators");
          showPopupWithContent(e, "cosmo_guest_elevators");
        }}
        onMouseLeave={(e) => {
          animationEnd("cosmo_guest_elevators");
          hidePopup("cosmo_guest_elevators");
          resetCosmoHighlightPOI("");
        }}
        onTouchEnd={(e) => {
          hidePopup("cosmo_guest_elevators");
          resetCosmoHighlightPOI("");
        }}
        fill="rgba(255,255,255,0.02)"
      >
        <g id="cosmo-l2-guest-elevator" transform="translate(3605 2081)">
          <rect width="55" height="111" stroke="none" />
          <rect x="2.5" y="2.5" width="50" height="106" fill="none" />
        </g>
        <path
          id="Path_2152"
          data-name="Path 2152"
          d="M331.46,1103.3h55.052v25.6H331.46Z"
          transform="translate(3485.331 1884.251)"
        />
      </g>

      <path
        className="poi-hover"
        id="cosmo_walkway_aria"
        d="M-3391.741-9105.1l2.392-98.182-65.3.881-10.09,41.389.163,52.9Z"
        transform="translate(6817.998 12311.55)"
        fill="rgba(255,255,255,0.02)"
        onTouchStart={(e) => {
          showPopupWithContent(e, "cosmo_walkway_aria");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("cosmo_walkway_aria");
          showPopupWithContent(e, "cosmo_walkway_aria");
        }}
        onMouseLeave={(e) => {
          animationEnd("cosmo_walkway_aria");
          hidePopup("cosmo_walkway_aria");
          resetCosmoHighlightPOI("");
        }}
        onTouchEnd={(e) => {
          hidePopup("cosmo_walkway_aria");
          resetCosmoHighlightPOI("");
        }}
      />

      <g
        transform="translate(3485.331 1884.251)"
        onTouchStart={(e) => {
          showPopupWithContent(e, "cosmo_convention_area_2");
          setActiveConvention("active-poi");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("cosmo_convention_area_2");
          showPopupWithContent(e, "cosmo_convention_area_2");
          setActiveConvention("active-poi");
        }}
        onMouseLeave={(e) => {
          animationEnd("cosmo_convention_area_2");
          hidePopup("cosmo_convention_area_2");
          setActiveConvention("");
          resetCosmoHighlightPOI("");
        }}
        onTouchEnd={(e) => {
          hidePopup("cosmo_convention_area_2");
          setActiveConvention("");
          resetCosmoHighlightPOI("");
        }}
        fill="rgba(255,255,255,0)"
        className={`poi-hover ${conventionActive} `}
        id="cosmo_convention_area_2"
      >
        <path
          data-name="Path 2058"
          d="M-3119.069-10408.453h67.99v46.4h-31.795v163.846h12.856v30.832h67.378v-30.832h54.566v107.691h-213.709l-.281-265.492h42.995Z"
          transform="translate(3210.61 10913.292)"
        />

        <g transform="translate(218.669 554.749)">
          <rect width="45" height="77" stroke="none" />
          <rect x="2.5" y="2.5" width="40" height="72" fill="none" />
        </g>
      </g>
    </>
  );
}

function CosmoLevel3({
  hoverContent,
  destcosmoChelsea,
  sourcecosmoChelsea,
  highlightarias,
  resetCosmoHighlightPOI,
}) {
  const [conventionActive, setActiveConvention] = useState("");
  const [restaurentActive, setrestaurentActive] = useState("");

  useEffect(() => {
    document.querySelectorAll(".poi-hover").forEach((val) => {
      val.classList.remove("active-poi");
    });
    setrestaurentActive("");

    if (highlightarias !== "") {
      if (highlightarias === "cosmo_convention_area_3") {
        setActiveConvention("active-poi");
      } else if (highlightarias === "cosmo_district") {
        setrestaurentActive("active-poi");
      } else {
        if (document.getElementById(highlightarias)) {
          document.getElementById(highlightarias).classList.add("active-poi");
        }
      }
    }
  }, [highlightarias]);

  return (
    <>
      <g
        id="cosmo_guest_elevators"
        className={`poi-hover`}
        onTouchStart={(e) => {
          showPopupWithContent(e, "cosmo_guest_elevators");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("cosmo_guest_elevators");
          showPopupWithContent(e, "cosmo_guest_elevators");
        }}
        onMouseLeave={(e) => {
          animationEnd("cosmo_guest_elevators");
          hidePopup("cosmo_guest_elevators");
          resetCosmoHighlightPOI("");
        }}
        onTouchEnd={(e) => {
          hidePopup("cosmo_guest_elevators");
          resetCosmoHighlightPOI("");
        }}
        fill="rgba(255,255,255,0.02)"
      >
        <path
          id="parking_garage_elevators"
          data-name="parking garage elevators"
          d="M-5340.9-11503.163v110.986h40.16v-110.986Z"
          transform="translate(9084 14412)"
        />
        <path
          id="tower_elevator"
          data-name="tower elevator"
          d="M-5340.9-11503.163v110.986h45.626v-110.986Z"
          transform="translate(9155.533 14401)"
        />
        <path
          id="chelsea-tower-elevator"
          d="M3697.976,2132.354l30.933,13.913-33.656,77.4-27.444-12.807Z"
        />
      </g>

      <g transform="translate(3484.32 1847.731)">
        <g
          className={`poi-hover ${restaurentActive}`}
          id="cosmo_district"
          transform="translate(2.07 974.576)"
          fill="rgba(255,255,255,0)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "cosmo_level_3_restaurent");
            setrestaurentActive("active-poi");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("cosmo_level_3_restaurent");
            showPopupWithContent(e, "cosmo_level_3_restaurent");
            setrestaurentActive("active-poi");
          }}
          onMouseLeave={(e) => {
            animationEnd("cosmo_level_3_restaurent");
            hidePopup("cosmo_level_3_restaurent");
            setrestaurentActive("");
            resetCosmoHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("cosmo_level_3_restaurent");
            setrestaurentActive("");
            resetCosmoHighlightPOI("");
          }}
        >
          <g data-name="Rectangle 4259" transform="translate(39.61 -0.308)">
            <rect width="129" height="110" />
            <rect x="2.5" y="2.5" width="124" height="105" />
          </g>
          <g data-name="Rectangle 4260" transform="translate(373.61 1.692)">
            <rect width="58" height="185" />
            <rect x="2.5" y="2.5" width="53" height="180" />
          </g>
          <path
            data-name="Path 2083"
            d="M-2955.179-9542.712l86.928-.013V-9434.4l-86.928-53.268Z"
            transform="translate(3126.124 9626.125)"
          />
          <g data-name="Path 2084" transform="translate(323.476 187.527)">
            <path d="M0,0H107.594l-1.336,83.59H0Z" />
            <path d="M 5.000007629394531 5.000007629394531 L 5.000007629394531 78.58953094482422 L 101.337646484375 78.58953094482422 L 102.513916015625 5.000007629394531 L 5.000007629394531 5.000007629394531 M 7.62939453125e-06 7.62939453125e-06 L 107.5944747924805 7.62939453125e-06 L 106.2583694458008 83.58953094482422 L 7.62939453125e-06 83.58953094482422 L 7.62939453125e-06 7.62939453125e-06 Z" />
          </g>
          <path
            data-name="Path 2085"
            d="M-2733.325-9225.093l104.033.291v45.954l-47.459,90.343h-108.024v-82.563Z"
            transform="translate(3057.407 9498.038)"
          />
          <path
            data-name="Path 2086"
            d="M-2987.365-9108.076l114.744-23.011v80.49l-63.932.309-50.8.382Z"
            transform="translate(3141.487 9460.13)"
          />
          <path
            data-name="Path 2087"
            d="M-3241.641-9185.281l94.988.638,36.038-41.7,18,75.9.77,62.148-149.745.859Z"
            transform="translate(3241.641 9498.542)"
          />
          <path
            data-name="Path 2088"
            d="M-3241.641-9378.282h32.769v35.294h33.035v-33.789l40.494,17.535,23.325,67.011-36.327,42.25h-93.219Z"
            transform="translate(3241.641 9559.813)"
          />
        </g>
      </g>

      <path
        className={`poi-hover`}
        id="cosmo_chelsea_theatre"
        d="M-2810.463-11313.159l152.992.127-.592,263.739-135.97-39.436-25.227-10.932-13.854-9.395-10.1-13.164-7.044-16.051-4.051-16.773-3.044-20.966v-87.848h46.885Z"
        transform="translate(6573.063 13162.373)"
        fill="rgba(255,255,255,0.03)"
        onTouchStart={(e) => {
          showPopupWithContent(e, "cosmo_chelsea_theatre");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("cosmo_chelsea_theatre");
          showPopupWithContent(e, "cosmo_chelsea_theatre");
        }}
        onMouseLeave={(e) => {
          animationEnd("cosmo_chelsea_theatre");
          hidePopup("cosmo_chelsea_theatre");
          resetCosmoHighlightPOI("");
        }}
        onTouchEnd={(e) => {
          hidePopup("cosmo_chelsea_theatre");
          resetCosmoHighlightPOI("");
        }}
      />

      <g
        className={`poi-hover ${conventionActive} `}
        onTouchStart={(e) => {
          showPopupWithContent(e, "cosmo_convention_area_3");
          setActiveConvention("active-poi");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("cosmo_convention_area_3");
          showPopupWithContent(e, "cosmo_convention_area_3");
          setActiveConvention("active-poi");
        }}
        onMouseLeave={(e) => {
          animationEnd("cosmo_convention_area_3");
          hidePopup("cosmo_convention_area_3");
          setActiveConvention("");
          resetCosmoHighlightPOI("");
        }}
        onTouchEnd={(e) => {
          hidePopup("cosmo_convention_area_3");
          setActiveConvention("");
          resetCosmoHighlightPOI("");
        }}
        fill="rgba(255,255,255,0.05)"
        id="cosmo_convention_area_3"
        transform="translate(3484.32 1847.731)"
      >
        <g
          id="Rectangle_4243"
          data-name="Rectangle 4243"
          transform="translate(229.68 0.269)"
        >
          <rect width="44" height="46" stroke="none" />
          <rect x="2.5" y="2.5" width="39" height="41" fill="none" />
        </g>
        <g
          id="Rectangle_4244"
          data-name="Rectangle 4244"
          transform="translate(29.68 15.269)"
        >
          <rect width="58" height="154" stroke="none" />
          <rect x="2.5" y="2.5" width="53" height="149" fill="none" />
        </g>
        <g
          id="Rectangle_4246"
          data-name="Rectangle 4246"
          transform="translate(-0.32 206.269)"
        >
          <rect width="68" height="188" stroke="none" />
          <rect x="2.5" y="2.5" width="63" height="183" fill="none" />
        </g>
        <g
          id="Rectangle_4247"
          data-name="Rectangle 4247"
          transform="translate(117.68 406.269)"
        >
          <rect width="46" height="57" stroke="none" />
          <rect x="2.5" y="2.5" width="41" height="52" fill="none" />
        </g>
        <g
          id="Rectangle_4248"
          data-name="Rectangle 4248"
          transform="translate(41.68 632.269)"
        >
          <rect width="219" height="340" stroke="none" />
          <rect x="2.5" y="2.5" width="214" height="335" fill="none" />
        </g>
        <g
          id="Rectangle_4245"
          data-name="Rectangle 4245"
          transform="translate(129.68 15.269)"
        >
          <rect width="56" height="156" stroke="none" />
          <rect x="2.5" y="2.5" width="51" height="151" fill="none" />
        </g>
      </g>
    </>
  );
}

function CosmoLevel4({ hoverContent, highlightarias, resetCosmoHighlightPOI }) {
  const [conventionActive, setActiveConvention] = useState("");

  useEffect(() => {
    document.querySelectorAll(".poi-hover").forEach((val) => {
      val.classList.remove("active-poi");
    });
    if (highlightarias !== "") {
      if (highlightarias === "cosmo_convention_area_4") {
        setActiveConvention("active-poi");
      } else {
        if (document.getElementById(highlightarias)) {
          document.getElementById(highlightarias).classList.add("active-poi");
        }
      }
    }
  }, [highlightarias]);

  return (
    <>
      <g
        className={`poi-hover`}
        id="cosmo_guest_elevators"
        onTouchStart={(e) => {
          showPopupWithContent(e, "cosmo_guest_elevators");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("cosmo_guest_elevators");
          showPopupWithContent(e, "cosmo_guest_elevators");
        }}
        onMouseLeave={(e) => {
          animationEnd("cosmo_guest_elevators");
          hidePopup("cosmo_guest_elevators");
          resetCosmoHighlightPOI("");
        }}
        onTouchEnd={(e) => {
          hidePopup("cosmo_guest_elevators");
          resetCosmoHighlightPOI("");
        }}
        fill="rgba(255,255,255,0.02)"
        data-name="Elevators"
      >
        <path
          id="chelsea_-tower-elevator"
          data-name="chelsea -tower-elevator"
          d="M3666.326,2213l67.7,26.721,8.893,3.489,39.443-115.691-79.269-29.784h0Z"
        />
        <path id="tower-elevator" d="M3876.019,2916.781v82.58h-58.8v-82.58Z" />
      </g>

      <path
        id="cosmo_pool"
        d="M-3133.881-9384.318h194.3v17.061h68.716v51.182h-54.5v84.354l159.705,3.791v52.13l-61.133,98.571-372.961,4.739v-176.56l45.021-44.753,20.852-40.281Z"
        transform="translate(6683.177 12312.245)"
        className="poi-hover"
        fill="rgba(255,255,255,0.04)"
        onTouchStart={(e) => {
          showPopupWithContent(e, "cosmo_pool");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("cosmo_pool");
          showPopupWithContent(e, "cosmo_pool");
        }}
        onMouseLeave={(e) => {
          animationEnd("cosmo_pool");
          hidePopup("cosmo_pool");
          resetCosmoHighlightPOI("");
        }}
        onTouchEnd={(e) => {
          hidePopup("cosmo_pool");
          resetCosmoHighlightPOI("");
        }}
      />

      {/* <path
        className="poi-hover"
        id="cosmo_pool"
        d="M-3062.46-9224.241l39.806,35.083,39.114-8.261,52,76.95-198.869,4.354Z"
        transform="translate(6683.177 12312.245)"
        fill="rgba(255,255,255,0.04)"
        onTouchStart={(e) => {
          showPopupWithContent(e, "cosmo_pool");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("cosmo_pool");
          showPopupWithContent(e, "cosmo_pool");
        }}
        onMouseLeave={(e) => {
          animationEnd("cosmo_pool");
          hidePopup("cosmo_pool");
          resetCosmoHighlightPOI("");
        }}
        onTouchEnd={(e) => {
          hidePopup("cosmo_pool");
          resetCosmoHighlightPOI("");
        }}
      /> */}

      <g
        transform="translate(3483.398 1845.887)"
        fill="rgba(255,255,255,0.07)"
        onTouchStart={(e) => {
          showPopupWithContent(e, "cosmo_convention_area_4");
          setActiveConvention("active-poi");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("cosmo_convention_area_4");
          showPopupWithContent(e, "cosmo_convention_area_4");
          setActiveConvention("active-poi");
        }}
        onMouseLeave={(e) => {
          animationEnd("cosmo_convention_area_4");
          hidePopup("cosmo_convention_area_4");
          setActiveConvention("");
          resetCosmoHighlightPOI("");
        }}
        className={`poi-hover ${conventionActive} `}
        id="cosmo_convention_area_4"
        onTouchEnd={(e) => {
          hidePopup("cosmo_convention_area_4");
          setActiveConvention("");
          resetCosmoHighlightPOI("");
        }}
      >
        <g
          id="Rectangle_4263"
          data-name="Rectangle 4263"
          transform="translate(391.603 1078.113)"
          fill="rgba(255,255,255,0)"
        >
          <rect width="42" height="73" stroke="none" />
          <rect x="2.5" y="2.5" width="37" height="68" fill="none" />
        </g>
        <g
          id="Rectangle_4249"
          data-name="Rectangle 4249"
          transform="translate(34.602 16.113)"
        >
          <rect width="158" height="156" stroke="none" />
          <rect x="2.5" y="2.5" width="153" height="151" fill="none" />
        </g>
        <g
          id="Rectangle_4252"
          data-name="Rectangle 4252"
          transform="translate(46.602 633.113)"
        >
          <rect width="214" height="446" stroke="none" />
          <rect x="2.5" y="2.5" width="209" height="441" fill="none" />
        </g>
        <g
          id="Rectangle_4250"
          data-name="Rectangle 4250"
          transform="translate(233.602 0.113)"
        >
          <rect width="39" height="174" stroke="none" />
          <rect x="2.5" y="2.5" width="34" height="169" fill="none" />
        </g>
        <g
          id="Rectangle_4251"
          data-name="Rectangle 4251"
          transform="translate(-0.398 204.113)"
        >
          <rect width="70" height="186" stroke="none" />
          <rect x="2.5" y="2.5" width="65" height="181" fill="none" />
        </g>
      </g>
    </>
  );
}
